import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    ASSET_ITEM_CLEAR: "ASSET_ITEM_CLEAR",
    ASSET_ITEM_SET: "ASSET_ITEM_SET",
    ASSET_ITEM_UPDATE: "ASSET_ITEM_UPDATE",

    ASSET_PATCH_FAILURE: "ASSET_PATCH_FAILURE",
    ASSET_PATCH_REQUEST: "ASSET_PATCH_REQUEST",
    ASSET_PATCH_SUCCESS: "ASSET_PATCH_SUCCESS",

    ASSETS_CLEAR: "ASSETS_CLEAR",

    ASSETS_GET_FAILURE: "ASSETS_GET_FAILURE",
    ASSETS_GET_REQUEST: "ASSETS_GET_REQUEST",
    ASSETS_GET_SUCCESS: "ASSETS_GET_SUCCESS",

    GET_SELECTED_ASSET_FAILURE: "GET_SELECTED_ASSET_FAILURE",
    GET_SELECTED_ASSET_REQUEST: "GET_SELECTED_ASSET_REQUEST",
    GET_SELECTED_ASSET_SUCCESS: "GET_SELECTED_ASSET_SUCCESS",

    ASSETS_SET: "ASSETS_SET"
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.ASSETS_CLEAR
    }),

    itemClear: () => ({
        type: actionTypes.ASSET_ITEM_CLEAR
    }),
    itemSet: (asset: any) => ({
        type: actionTypes.ASSET_ITEM_SET,
        payload: { asset }
    }),
    itemUpdate: (asset: any) => ({
        type: actionTypes.ASSET_ITEM_UPDATE,
        payload: { asset }
    }),

    getRequest: () => ({
        type: actionTypes.ASSETS_GET_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.ASSETS_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.ASSETS_GET_FAILURE
    }),
    getSuccess: (assets: Array<any>) => ({
        type: actionTypes.ASSETS_GET_SUCCESS,
        payload: { assets }
    }),
    getFailure: (error: Error) => ({
        type: actionTypes.ASSETS_GET_FAILURE,
        error
    }),

    getSelectedAssetRequest: (options) => ({
        type: actionTypes.GET_SELECTED_ASSET_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.GET_SELECTED_ASSET_SUCCESS,
        [ERROR_ACTION]: actionTypes.GET_SELECTED_ASSET_FAILURE,
        payload: { options }
    }),
    getSelectedAssetSuccess: (assets: Array<any>) => ({
        type: actionTypes.GET_SELECTED_ASSET_SUCCESS,
        payload: { assets }
    }),
    getSelectedAssetFailure: (error: Error) => ({
        type: actionTypes.GET_SELECTED_ASSET_FAILURE,
        error
    }),

    patchRequest: (asset: any) => ({
        type: actionTypes.ASSET_PATCH_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.ASSET_PATCH_SUCCESS,
        [ERROR_ACTION]: actionTypes.ASSET_PATCH_FAILURE,
        payload: { asset }
    }),
    patchSuccess: (asset: any) => ({
        type: actionTypes.ASSET_PATCH_SUCCESS,
        payload: { asset }
    }),
    patchFailure: (error: Error) => ({
        type: actionTypes.ASSET_PATCH_FAILURE,
        error
    }),

    set: (assets: Array<any>) => ({
        type: actionTypes.ASSETS_SET,
        payload: { assets }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
